module.exports = __webpack_public_path__ + "static/media/agency-notmilk.9c131e0a.png";